import { render, staticRenderFns } from "./LeCopyToClipboard.vue?vue&type=template&id=a8c97dd2"
import script from "./LeCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./LeCopyToClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports